import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";
//import _ from 'lodash';

class MunicipalitySearch extends Component {
	render() {
		const { municipalities } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>
			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={municipalities.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	_submitSearch() {
		const {municipalities} = this.props;
		this.props.municipalitiesShow(1,municipalities.filters);
	}

	_searchChange(event){
		this.props.change('municipalities.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('municipalities.filters');
		this.props.municipalitiesShow(1);
	}
}

export default SecureLayout(MunicipalitySearch);



// WEBPACK FOOTER //
// ./src/elements/municipalities/widget/municipality_search.jsx